export const attrIncludesTerm = (attr, term) => (item) =>
    item[attr]?.toLowerCase().includes(term.toLowerCase());
